import { Component, Input } from '@angular/core';
import { NgbActiveModal }   from '@ng-bootstrap/ng-bootstrap';

import { SessionService } from '../../sessions/session.service';

@Component({
  selector   : 'confirmation-remember',
  template: require('./confirmation.remember.component.html')
})
export class ConfirmationRememberComponent {
  @Input() message    : string;
  @Input() storageName: string;
  @Input() type       : string;

  remember = false;

  constructor (
    public activeModal    : NgbActiveModal,
    private sessionService: SessionService
  ) {}

  yes () : void {
    if ( this.remember ) {
      this.sessionService.setKey(this.storageName, true);
    }

    this.activeModal.close(true);
  }
}
